export const formatPhone = (phoneNumber) => {
    if (!phoneNumber)
        return 'N/A';
    const phoneNumberClean = phoneNumber.replace(/-/g, '');
    return `${phoneNumberClean.slice(0, 3)}-${phoneNumberClean.slice(3, 6)}-${phoneNumberClean.slice(6)}`;
};
export const copyMessage = (text) => navigator.clipboard.writeText(text);
export const formatAddress = (address) => {
    if (!address)
        return 'N/A';
    let ret = '';
    if (address.civicNumber)
        ret = ret.concat(address.civicNumber);
    if (address.street)
        ret = ret.concat(` ${address.street}`);
    if (address.city)
        ret = ret.concat(`, ${address.city}`);
    if (address.stateIso)
        ret = ret.concat(`, ${address.stateIso}`);
    if (address.country)
        ret = ret.concat(`, ${address.country}`);
    if (address.postalCode)
        ret = ret.concat(`, ${address.postalCode.toUpperCase()}`);
    return ret;
};
export const removeDiacritics = (text) => {
    if (!text.trim()) {
        return text;
    }
    const normalizedText = text.normalize('NFD');
    const removedDiacritics = normalizedText.replace(/[\u0300-\u036f]/g, '');
    return removedDiacritics.normalize('NFC');
};
